<template>
	<UPage
		:ui="{
			root: 'w-full my-auto px-4 sm:px-6 lg:px-8 py-0 relative isolate overflow-hidden'
		}"
	>
		<div class="max-w-container mx-auto w-full justify-items-center">
			<section class="w-full sm:max-w-4xl">
				<h2 class="text-4xl sm:text-5xl flex leading-13 pb-4 sm:leading-14 font-semibold flex-col tracking-tight text-center">
					<span class="text-primary">
						{{ $t('already-registered.title1') }}
					</span>
					<span class="text-default">
						{{ $t('already-registered.title2') }}
					</span>
				</h2>
				<p class="pt-4 text-xl sm:text-2xl text-center pb-6 sm:pb-8 font-medium text-default max-w-2xl mx-auto text-pretty">
					{{ $t('already-registered.question') }}
				</p>
			</section>
			<div class="max-w-2xl w-full py-2">
				<div
					v-if="address"
					class="w-full flex flex-col gap-2 justify-start"
				>
					<div class="pt-4 text-lg sm:text-xl text-left font-semibold text-default">
						{{ $t('already-registered.location-address') }}
					</div>
					<div class="w-full flex items-center gap-1 justify-center sm:justify-start">
						<UIcon
							v-if="address"
							color="primary"
							name="i-lucide-map-pin"
							class="h-8 w-8 shrink-0 text-primary"
						/>
						<span class="text-lg font-bold text-pretty pr-2">
							{{ address }}
						</span>
						<UButton
							variant="ghost"
							color="primary"
							:to="localePath('/get-fiber')"
							class="font-semibold transition-all duration-100 ease-in-out text-primary underline-offset-2 hover:underline decoration-primary decoration-2"
						>
							{{ $t('already-registered.change-location-address') }}
						</UButton>
					</div>
				</div>
			</div>

			<div class="flex flex-col md:flex-row gap-8 sm:gap-12 max-w-xs md:max-w-2xl mx-auto py-12">
				<div class="flex flex-col justify-between gap-4 sm:gap-8">
					<span class="text-center text-pretty">
						{{ $t('already-registered.yes-copy') }}
					</span>
					<div class="flex justify-center">
						<div class="w-44">
							<UButton
								size="lg"
								:to="localePath('/login')"
								:label="$t('already-registered.sign-in')"
								class="w-full"
							/>
						</div>
					</div>
				</div>
				<div class="flex flex-col gap-4 sm:gap-8">
					<span class="text-center text-pretty">
						{{ $t('already-registered.no-moving-copy') }}
					</span>
					<div class="flex justify-center">
						<div class="w-44">
							<UButton
								size="lg"
								:to="localePath('/get-fiber?fiber=alreadyRegistered&moving_in=true')"
								:label="$t('already-registered.sign-up')"
								class="w-full"
							/>
						</div>
					</div>
				</div>
				<div class="flex flex-col gap-4 sm:gap-8">
					<span class="text-center text-pretty">
						{{ $t('already-registered.have-questions-copy') }}
					</span>
					<div class="flex justify-center w-full mt-auto">
						<div class="w-44">
							<UButton
								:to="localePath('/contact')"
								size="lg"
								:label="$t('already-registered.contact-us')"
								class="w-full"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</UPage>
</template>

<script setup lang="ts">
import { useAddressLocalStorage } from '@/composables/useLocalStorage'

const localePath = useLocalePath()

const { cachedAddressResponse } = useAddressLocalStorage()

const address = computed(() => {
	return cachedAddressResponse?.value?.address
})
</script>
